<template>
    <div style="background-color: white">
        <!-- 搜索框和按钮 -->
        <el-row style="padding-top: 10px">
            <el-col :span="24">
                <el-button class="btn" type="primary" @click="handleAdd" icon="el-icon-plus">新增版本</el-button>
                <el-form :inline="true" ref="searchModel" :model="searchModel" class="demo-form-inline"
                    style="float: right !important" @submit.native.prevent>
                    <el-form-item label="状态">
                        <el-select placeholder="请选择" v-model="searchModel.status" clearable style="width: 120px">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="禁用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="getList">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

        <!-- 数据表格 -->
        <el-row>
            <el-col :span="24">
                <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
                    :cell-style="{ textAlign: 'center' }" :data="dataList" stripe
                    style="width: 100%; text-align: center">
                    <el-table-column type="index" label="序号" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="versionName" label="版本名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="versionCode" label="版本号" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="updateContent" label="更新内容" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="forceUpdate" label="强制更新" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.forceUpdate == 1" style="color: #f56c6c">是</span>
                            <span v-else style="color: #909399">否</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                                @change="handleStatusChange(scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small"
                                style="color: #f56c6c">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <!-- 分页 -->
        <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
            <el-pagination v-if="dataList.length > 0" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" style="float: right">
            </el-pagination>
        </el-col>

        <!-- 新增/编辑弹窗 -->
        <el-dialog :visible.sync="dialogVisible" :title="isEdit ? '编辑版本' : '新增版本'" width="600px"
            :close-on-click-modal="false">
            <el-form :model="form" :rules="rules" ref="form" label-width="120px" label-position="left"
                class="version-form">
                <el-form-item label="App类型" prop="appType">
                    <el-radio-group v-model="form.appType">
                        <el-radio :label="1">Android</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="上传安装包" prop="downloadUrl">
                    <el-upload :auto-upload="false" :limit="1" :file-list="fileList" :on-change="handleFileChange"
                        :on-remove="handleFileRemove" accept=".apk">
                        <el-button size="small" type="primary">选择文件</el-button>
                        <div slot="tip" class="el-upload__tip">请上传 .apk 安装包文件</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="更新内容" prop="updateContent">
                    <el-input type="textarea" v-model="form.updateContent" :rows="4" placeholder="请输入更新内容"></el-input>
                </el-form-item>
                <el-form-item label="强制更新" prop="forceUpdate">
                    <el-switch v-model="form.forceUpdate" :active-value="1" :inactive-value="0" active-text="是"
                        inactive-text="否"></el-switch>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用"
                        inactive-text="禁用"></el-switch>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="form.remark" :rows="2" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getAppVersionList, addAppVersion, updateAppVersion, deleteAppVersion, uploadApk } from "@/api/api";

export default {
    name: "AppVersion",
    data() {
        return {
            searchModel: {
                appType: null,
                status: null
            },
            dataList: [],
            pageIndex: 1,
            pagesize: 10,
            total: 0,
            dialogVisible: false,
            isEdit: false,
            submitLoading: false,
            form: {
                id: null,
                appType: 1,
                downloadUrl: '',
                updateContent: '',
                forceUpdate: 0,
                status: 1,
                remark: ''
            },
            rules: {
                appType: [{ required: true, message: '请选择App类型', trigger: 'change' }],
                downloadUrl: [{ required: true, message: '请上传安装包', trigger: 'change' }]
            },
            fileList: []
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            const params = {
                pageIndex: this.pageIndex,
                pageSize: this.pagesize,
                ...this.searchModel
            };
            getAppVersionList(params).then(res => {
                if (res.status === 200) {
                    this.dataList = res.data.records || res.data.list || [];
                    this.total = res.data.total || 0;
                }
            });
        },
        handleSizeChange(val) {
            this.pagesize = val;
            this.pageIndex = 1;
            this.getList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getList();
        },
        handleAdd() {
            this.isEdit = false;
            this.form = {
                id: null,
                appType: 1,
                downloadUrl: '',
                updateContent: '',
                forceUpdate: 0,
                status: 1,
                remark: ''
            };
            // 不设置versionCode和versionName，让后端自动生成
            this.fileList = [];
            this.dialogVisible = true;
        },
        handleEdit(row) {
            this.isEdit = true;
            this.form = { ...row };
            this.fileList = row.downloadUrl ? [{ name: row.downloadUrl.split('/').pop(), url: row.downloadUrl }] : [];
            this.dialogVisible = true;
        },
        handleFileChange(file, files) {
            this.uploadFile(file.raw);
        },
        handleFileRemove() {
            this.form.downloadUrl = '';
            this.fileList = [];
        },
        async uploadFile(file) {
            const formData = new FormData();
            formData.append('file', file);
            try {
                const res = await uploadApk(formData);
                if (res.status === 200 && res.data && res.data.path) {
                    this.form.downloadUrl = res.data.path;
                    this.$message.success('APK上传成功');
                } else {
                    this.$message.error(res.message || '上传失败');
                }
            } catch (e) {
                this.$message.error('上传失败');
            }
        },
        handleSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    const action = this.isEdit ? updateAppVersion : addAppVersion;
                    action(this.form).then(res => {
                        if (res.status === 200) {
                            this.$message.success(this.isEdit ? '更新成功' : '添加成功');
                            this.dialogVisible = false;
                            this.getList();
                        } else {
                            this.$message.error(res.message || '操作失败');
                        }
                    }).finally(() => {
                        this.submitLoading = false;
                    });
                }
            });
        },
        handleStatusChange(row) {
            updateAppVersion(row).then(res => {
                if (res.status === 200) {
                    this.$message.success('状态更新成功');
                } else {
                    this.$message.error(res.message || '更新失败');
                    this.getList();
                }
            });
        },
        handleDelete(row) {
            this.$confirm('确定要删除该版本吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteAppVersion(row.id).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.getList();
                    } else {
                        this.$message.error(res.message || '删除失败');
                    }
                });
            });
        }
    }
};
</script>

<style scoped>
.app-version-container {
    padding: 20px;
}

.version-form {
    padding-left: 20px;
}

.version-form .el-form-item__content {
    text-align: left;
    margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/app/AppVersion.vue